import { useAppSelector } from 'store/configureStore'
import projectImageUrl from 'services/APIs/InternalAPI/ProjectImages'
import { RootAppState } from 'store/configureStore'
import { useOrganizationAndProjectContext } from 'utils/useOrganizationContext'
import { bomItemThumbnailSelector } from './store/selectors/bomItemThumbnailSelector'

export function useBomItemThumbnailImageSrc(
  bomItemId: string,
  show2dModel?: boolean
) {
  const { partyId, projectId } = useOrganizationAndProjectContext()
  const thumbnailFilename = useAppSelector((state: RootAppState) =>
    bomItemThumbnailSelector(state, bomItemId, false, show2dModel)
  )

  const imageSrc = thumbnailFilename
    ? projectImageUrl(partyId, projectId, thumbnailFilename)
    : ''

  return {
    thumbnailFilename,
    imageSrc,
  }
}
